<script>
import GroupMembers from '@components/modal/members'
import UserFollow from '@components/user/follow'
export default {
  components: {
    GroupMembers,
    UserFollow,
  },
  data: () => {
    return {
      is_joined: false,
      is_requested: false,
      groupMembers: null,
      group: null,
    }
  },
  created() {
    this.group = this.$store.state.group.groupDetail.data
    this.is_joined = this.group.join.data.is_joined
    this.is_requested = this.group.join.data.is_requested
    this.getGroupMembers()
  },
  methods: {
    handleJoinGroup() {
      const payload = {
        group_id: this.group.id,
      }
      this.$store
        .dispatch('group/joinGroup', payload)
        .then((response) => {
          if (this.is_joined) {
            this.is_requested = false
            this.is_joined = false
          } else if (!this.is_joined & this.is_requested) {
            this.is_requested = false
          } else if (!this.is_joined & !this.is_requested) {
            this.is_requested = true
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleLeaveGroup() {
      const payload = {
        group_id: this.group.id,
      }
      this.$store
        .dispatch('group/leaveGroup', payload)
        .then((response) => {
          this.is_requested = false
          this.is_joined = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getGroupMembers() {
      const payload = {
        page: this.page,
        group_id: this.group.id,
        is_manage: +(
          this.group.join.data.role === 'admin' ||
          this.group.join.data.role === 'owner'
        ),
        type: 0,
      }
      this.$store
        .dispatch('group/getGroupMembers', payload)
        .then((response) => {
          this.groupMembers = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<template>
  <div class="group-top">
    <div v-if="group">
      <div class="group-panel">
        <div class="group-left">
          <div to="#" class="group-cnt">
            <div class="img-box">
              <img
                :src="group.image_url"
                onerror="this.src='/group_avatar.png';"
                class="rounded-circle img-fluid"
                :style="{ width: 50 + 'px', height: 50 + 'px' }"
              />

            </div>
            <h2 class="txt-box">
              <p>{{ group.name }}</p>
              <div>
                    <p class="type" style="display: inline-block;color: #007bff;">{{ $t('group_type.' + group.type.data.name) }}</p>
                    <a :href="(group.website && group.website.startsWith('http')) ? group.website : 'https://' + group.website" target="_blank" class="type" style="display: inline-block;  float: right;color: #007bff;">{{ group.website }}</a>
              </div>
              <p class="summary">
                {{ group.greeting ? group.greeting.length > 400?group.greeting.substr(0,400) + '...':group.greeting  : ' ' }}
              </p>
            </h2>
          </div>
        </div>
        <div class="group-num">
          <ul>
            <li
              ><b-link v-b-modal.userMember
                >{{ $t('group.member') }}
                <em>{{ group.total_member }}</em></b-link
              ></li
            >
            <li
              ><b-link to="#"
                >{{ $t('group.post') }} <em>{{ group.total_post }}</em></b-link
              ></li
            >
          </ul>
        </div>
        <b-dropdown
          v-if="group && group.join.data.role !== 'owner'"
          right
          text="setting more"
          class="setting-more"
        >
          <ul class="more-list">
            <li
              v-if="(is_joined === false) & (is_requested === false)"
              class="more-share"
              ><a class="action" @click="handleJoinGroup">{{
                $t('common.join')
              }}</a></li
            >
            <li v-if="is_requested" class="more-share"
              ><a class="action" @click="handleJoinGroup">{{
                $t('common.requested')
              }}</a></li
            >
            <li v-if="is_joined === true" class="more-edit"
              ><a class="action" @click="handleLeaveGroup">{{
                $t('common.to_leave')
              }}</a></li
            >
          </ul>
        </b-dropdown>
      </div>
      <GroupMembers my-id="userMember">
        <div
          v-for="(member, index) in groupMembers"
          :key="index"
          class="follow-item"
        >
          <UserFollow :user="member" />
        </div>
      </GroupMembers>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.group-left {
  width: 70%; /* Set width to 70% */
  padding-right: 12px;
}
.group-panel {
  padding: $size-pd;
  border: 1px solid $color-primary-bd;
  display: flex;
  justify-content: space-between;
  position: relative;
  @include media-breakpoint-down(md) {
    padding: $size-pd-inner-sp;
    flex-direction: column;
  }
}
.group-cnt {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @include media-breakpoint-down(md) {
    align-items: flex-start;
  }
}

.img-box {
  margin-right: 20px;
  width: 70px;
  @include media-breakpoint-down(md) {
    margin-right: 10px;
  }
}

.txt-box {
  flex: 1;
  font-size: 18px;
  font-weight: 500;
  color: $color-primary;
  text-overflow: ellipsis;
  word-break: break-all;
  margin-bottom: 0;
  p {
    margin: 0;
  }
  .type {
    color: $color-sub;
    font-size: 14px;
    font-weight: normal;
    margin-top: 5px;
  }
  .summary {
    color: $color-text;
    font-size: 14px;
    font-weight: normal;
    margin-top: 10px;
    white-space: pre-line;
    word-break: break-word; /* Break words at any character */
    overflow-wrap: break-word; /* Handles long words that can't be broken */
  }
}

.group-num {
  margin-top: 40px;
  padding-left: 30px;
  border-left: 1px solid $color-primary-bd;
  @include media-breakpoint-down(md) {
    border-left: 0;
    border-top: 1px solid $color-primary-bd;
    padding: 0;
    margin-top: 25px;
  }
  ul {
    list-style: none;
    padding: 8px 0;
    margin: 0;
    @include media-breakpoint-down(md) {
      display: flex;
      padding: 8px $size-pd-inner-sp 0;
    }
    li {
      &:not(:last-child) {
        margin-bottom: 10px;
        @include media-breakpoint-down(md) {
          margin-right: 20px;
        }
      }
    }
    a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: $color-sub;
      @include media-breakpoint-down(md) {
        justify-content: flex-start;
      }
      em {
        font-style: normal;
        color: $color-primary;
        margin-left: 120px;
        @include media-breakpoint-down(md) {
          margin-left: 16px;
        }
      }
    }
  }
}
.setting-more {
  position: absolute;
  right: $size-pd;
  top: $size-pd;
  @include media-breakpoint-down(md) {
    right: $size-pd-inner-sp;
    top: $size-pd-inner-sp;
  }
  /deep/ {
    .btn {
      text-indent: -1987em;
      background: transparent url(~@assets/images/icon/icon_more.png) no-repeat;
      border-radius: 0;
      border: 0;
      padding: 0;
      margin: 8px 0 0;
      width: 20px;
      height: 20px;
      @include hover-focus {
        outline: 0;
        box-shadow: none;
      }
    }
    .dropdown-menu-right {
      padding: 0;
      margin: 0;
      border: 1px solid $color-primary-bd;
      border-radius: 0;
      .more-list {
        padding: 0;
        margin: 0;
        list-style: none;
        li {
          &:not(:last-child) {
            border-bottom: 1px solid $color-primary-bd;
          }
        }
        .action {
          padding: 8px 8px 8px 20px;
          display: block;
          font-size: 14px;
          color: $color-more;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
